package com.schoolconnect.app.feature.links

data class LinksUiState(
    val isLoading: Boolean = false,
    val errorMessage: String = "",
    val searchQuery: String = "",
    val selectedId: String = "",
    val items: List<String> = emptyList()
)

sealed interface LinksUiEvent {
    data object BackClicked : LinksUiEvent
    data object RefreshClicked : LinksUiEvent
    data class SearchChanged(val query: String) : LinksUiEvent
}

